import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
// import convert from '../../helpers/convert'
import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
import moment from 'moment'
import {Row, Col} from 'react-flexbox-grid'
import Loader from 'react-loader'
import Select from 'react-select'
import ReactTooltip from 'react-tooltip'
import {SlideDown} from 'react-slidedown'
import { Link, LinkIcon } from '../../components'
import Styles from './Returns.css'
import EsgConfig from '../../components/EsgConfig/EsgConfig';

/*
MINI COMPONENTS
*/
@CSSModules(Styles, {allowMultiple:false})
export class NoReturnsAvailable extends Component {
  render() {
    return (
      <div styleName='no-returns-avail'>
        <LinkIcon
          nospace={true}
          faclass='fa-exclamation-triangle'
        />
        &nbsp;
        Less than one year of returns available
      </div>
    )
  }
}

/*
COMPONENT CONSTRUCTOR
*/
@CSSModules(Styles, {allowMultiple:true})
export default class Returns extends Component {
  static propTypes = {
    shareClass: PropTypes.object.isRequired,
    fund: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired
  }
  constructor(props){
    super(props);

    // could be 1/3/6/12 month horizons in the future
    const timeHorizonOpts = {
      decade: [
        {
          value: 'trailing_return_y1',
          label: 'one year',
          shortLabel: '1-yr',
          numLabel: '1 year'
        },
        {
          value: 'trailing_return_y3',
          label: 'three years',
          shortLabel: '3-yr',
          numLabel: '3 years'
        },
        {
          value: 'trailing_return_y5',
          label: 'five years',
          shortLabel: '5-yr',
          numLabel: '5 years'
        },
        {
          value: 'trailing_return_y10',
          label: '10 years',
          shortLabel: '10-yr',
          numLabel: '10 years'
        }
      ]
    }

    const defaultTimeHorizons = timeHorizonOpts.decade

    /* we want the oldest shareclass performance available to be the initial
       time horizon used for comparison. if there is no shareclass performance
       for a horizon, set it to disabled, we won't show a button for it. if
       shareclass has no performance for any horizon, leave oldest shareclass
       performance as null. */
    let oldestSharePerf = null
    for (let i = 0; i < defaultTimeHorizons.length; i++) {
      if (props.shareClass[defaultTimeHorizons[i].value] === -1000.0) {
        props.shareClass[defaultTimeHorizons[i].value] = null
      }
      if (props.shareClass[defaultTimeHorizons[i].value]) {
        oldestSharePerf = defaultTimeHorizons[i]
        defaultTimeHorizons[i].disabled = false
      } else {
        defaultTimeHorizons[i].disabled = true
      }
    }

    // all benchmarks in config, but only those w/ 10-yr returns
    const benchmarks = config.coreBenchmarks.concat(config.extendedBenchmarks)
    const benchmarksWithPerf = benchmarks.filter((b)=>{
      return b.trailing_return_y10 !== ''
    })

    // choose first benchmark based on shareclass suggested benchmark
    const suggested = props.shareClass.morningstar_primary_benchmark
    const initBench = this.getInitBench(suggested, benchmarksWithPerf).pop()

    // morningstar clickthrough url
    const morningstarUrl = (props.shareClass.morningstar_url
                            || config.links.morningstar) + '?CID=DIS_IND063'

    this.state = {
      // all the time horizons available for comparisons and buttons
      // [{ value: 'trailing_return_y1',
      //    label: 'one year',
      //    shortLabel: '1-yr' },
      //  ... ]
      returnsTimeHorizon : defaultTimeHorizons,
      // the active time horizon being used for comparison
      // { value: 'trailing_return_y10',
      //   label: '10 years',
      //   shortLabel: '10-yr' }
      activeTimeHorizon: oldestSharePerf || null,
      // all the benchmarks available for comparisons and dropdowns
      allBenchmarks: benchmarksWithPerf,
      // the active benchmark being used for comparison
      // { fund_legal_name: 'iShares Core S&P 500 ETF',
      //   name: 'IVV - iShares Core S&P 500 ETF',
      //   ... }
      benchmark: initBench,
      /* array of differences resulting from subtracting benchmark returns.
         for each time horizon from shareclass returns from the same
         horizon. */
      // [ -6.35, 0.30, ... ]
      returnDiffs: this.calcReturnDiffs(defaultTimeHorizons,
                                        props.shareClass,
                                        initBench),
      /* ESG-keyed object with the current differences between shareclass and
         active benchmark ESG values. For each ESG object, the bench value is
         subtracted from the shareclass value and saved. These ESG diffs are
         recalculated if the benchmark changes. */
      // { fossils: -1.32,
      //   ... }
      esgDiffs: this.calcEsgDiffs(initBench),
      /* the default ESG comparison at start will be fossil fuels. If this
         page is actually carbon footprint or clean200, this will change the
         initial ESG comparison to reflect that. Right now this is only used
         for the table in the slidedown, all other components show comparisons
         for all ESG options. Only the table has esgSelect, which updates
         state.esg. This may be too much overhead for a minor feature */
      // { id: 'fossils',
      //   fieldLabel: 'c2f5coogutweight',
      //   ... }
      esg: this.getInitEsg(initBench),
      // clickthrough url
      morningstarUrl: morningstarUrl,
      // loading flags
      benchLoading: false,
      timeHorizonLoading: false,
      // expandable flags
      showExpandable: false,
      // ms for loading icon to display when settings changed
      loadingTime: 333
    }
  }
 /* ------------------------ */


  /*
  INITIALIZING HELPERS
  */
  getInitBench = (suggested, benchmarks) => {
    switch (suggested) {
      case 'MSCI ACWI NR USD':
        return this.findBenchByLabel('ACWI - iShares MSCI ACWI ETF',
                                     benchmarks)
      case 'MSCI ACWI Ex USA NR USD':
        return this.findBenchByLabel('ACWX - iShares MSCI ACWI ex U.S. ETF',
                                     benchmarks)
      default:
        return this.findBenchByLabel('IVV - iShares Core S&P 500 ETF',
                                     benchmarks)
    }
  }

  getInitEsg = (initBench) => {
    let initEsg = null
    Object.keys(EsgConfig.esgOptions).map((key) => {
      initEsg = (this.props.url.indexOf(EsgConfig.esgOptions[key].page) >= 0)
                ? EsgConfig.esgOptions[key]
                : initEsg
      return true
    })
    // default to first option in esgNamesLabels
    return initEsg || EsgConfig.esgOptions[EsgConfig.esgNamesLabels[0].value]
  }

  findBenchByLabel = (label, benchmarks) => {
    return benchmarks.filter((benchmark)=>{
      return label === benchmark.label
    })
  }
 /* ------------------------ */


  /*
  FORM CONTROL ON CHANGES
  */
  // onChange for benchmarkSelect
  benchmarkOnChange = (chosen) => {
    // chosen = { value, label }
    const nextBenchmark = this.findBenchByLabel(chosen.label,
                                                this.state.allBenchmarks)

    if (nextBenchmark.length > 0){
      const returnDiffs = this.calcReturnDiffs(this.state.returnsTimeHorizon,
                                               this.props.shareClass,
                                               nextBenchmark[0])

      const esgDiffs = this.calcEsgDiffs(nextBenchmark[0])

      this.setState({
        benchmark : nextBenchmark[0],
        returnDiffs : returnDiffs,
        esg: EsgConfig.esgOptions[this.state.esg.id],
        esgDiffs: esgDiffs,
        benchLoading: true
      })

      // for loading icon
      setTimeout(() => {
        this.setState({
          benchLoading: false
        })
      }, this.state.loadingTime)
    }
  }

  // onChange for esgSelect
  esgOnChange = (chosen) => {
    // chosen = { value, label }
    // update state to select a new ESG comparison
    // default to first option in esgNamesLabels
    const selection = chosen || EsgConfig.esgNamesLabels[0]
    const esg = EsgConfig.esgOptions[selection.value]

    this.setState({
      esg : esg
    })
  }
 /* ------------------------ */


  /*
  CALCULATION HELPERS
  calcReturnDiffs -> for each time horizon, difference between shareclass and
                     benchmark, returned as array
  calcEsgDiffs -> for each ESG option, difference between fund and
                  benchmark, returned as object
  */
  calcReturnDiffs = (timeHorizons, share, bench) => {
    return timeHorizons.map((timeHorizon) => {
      const key = timeHorizon.value
      return (share[key] && bench[key]) ? share[key] - bench[key] : null
    })
  }

  calcEsgDiffs = (bench) => {
    const newDiffs = {}
    Object.keys(EsgConfig.esgOptions).map((key) => {
      newDiffs[key] = (this.props.fund[EsgConfig.esgOptions[key].fieldLabel]
                       - bench[EsgConfig.esgOptions[key].benchLabel])
      return true
    })
    return newDiffs
  }
 /* ------------------------ */


  /*
  RENDER HELPERS
  renderEsgFormat -> apply format function of active esg to supplied value
  renderBenchmarkSelect -> render dropdown menu for benchmarks w/ on change
  */
  renderEsgFormat = (val, abs=false) => {
    /* if we have an item and a selected ESG apply the correct format function
       to the relevant field */
    if (val && this.state.esg && this.state.esg.format) {
      const absVal = (abs) ? Math.abs(val) : val
      return (
        <span>
          { this.state.esg.format(absVal) }
          &nbsp;
          { this.state.esg.units(absVal) }
        </span>
      )
    }
    return (  <span> / </span> )
  }

  renderBenchmarkSelect = () => {
    return (
      <div styleName='benchmark-select-wrap'>
        <Select
          name='form-field-name'
          value={this.state.benchmark}
          onChange={this.benchmarkOnChange}
          options={this.state.allBenchmarks}
          clearable={false}
        />
      </div>
    )
  }
 /* ------------------------ */


  /*
  renderCardTable
  */
  renderCardTable = (_shareClass, _fund) => {
    const renderCardTableHeader = (shareClass) => {
      const logo = require('../../../static/images/img-morningstar.png')
      const { investment_vehicle_id, ticker } = shareClass
      const url = this.state.morningstarUrl
      return (
        <div styleName='returns-container-headline-wrap'>
          <div styleName='returns-container-headlines'>
            <div styleName='returns-container-headline'>
              Financial performance
            </div>
            <div styleName='returns-container-subheading'>
              Performance data provided by
              <Link
                to={url}
                log={analytics.eventToMorningstar(investment_vehicle_id)}
              >
                <img
                  src={logo}
                  styleName='morningstar-logo-inline'
                  alt='Morningstar'
                />
              </Link>
              Find more financial data on {ticker} at&nbsp;
              <Link
                to={url}
                log={analytics.eventToMorningstar(investment_vehicle_id)}
              >
                Morningstar.com<LinkIcon />
              </Link>
            </div>
          </div>
        </div>
      )
    }

    const renderTimeHorizonButtongroup = () => {
      // horizon = {
      //   value: 'trailing_return_y1',
      //   label: 'one year',
      //   shortLabel: '1-yr'
      // }
      if (this.state.activeTimeHorizon){
        const isActive = (val) => {
          return val === this.state.activeTimeHorizon.shortLabel
                         ? 'active-btn'
                         : ''
        }

        const onClick = (selectedTimehorizon) => {
          const chosen = this.state.returnsTimeHorizon.filter(
            timehorizon => {
              return timehorizon.shortLabel === selectedTimehorizon
            }
          )
          if (chosen.length > 0) {
            const item = chosen.pop()
            if (item.shortLabel !== this.state.activeTimeHorizon.shortLabel) {
              this.setState({
                activeTimeHorizon: item,
                timeHorizonLoading: true
              })

              // for loading icon
              setTimeout(() => {
                this.setState({
                  timeHorizonLoading: false
                })
              }, this.state.loadingTime)
            }
          }
        }

        return (
          <div styleName='annual-return-timeline-buttongroup'>
            {
              this.state.returnsTimeHorizon.map(item => {
                return !item.disabled ? (
                  <div
                    key={item.shortLabel}
                    styleName={'annual-return-timeline-button '
                               + isActive(item.shortLabel)}
                    onClick={ () => { onClick(item.shortLabel) } }
                  >
                    <div styleName='annual-return-timeline-button-div'>
                      {item.numLabel}
                    </div>
                  </div>
                ) : (
                  <div
                    key={item.shortLabel}
                    styleName={'annual-return-timeline-button-disabled'}
                  >
                    <div styleName='annual-return-timeline-button-div'>
                      {item.numLabel}
                    </div>
                  </div>
                )
              })
            }
          </div>
        )
      } else {
        return (
          <NoReturnsAvailable />
        )
      }
    }

    const renderSettingsCard = (shareClass) => {
      let benchName =  null
      switch(shareClass.morningstar_primary_benchmark){
        case 'S&P 500 TR USD':
          benchName = 'S&P 500'
          break
        case 'MSCI ACWI NR USD':
          benchName = 'MSCI ACWI'
          break
        case 'MSCI ACWI Ex USA NR USD':
          benchName = 'MSCI ACWI Ex USA'
          break
        default:
          benchName = 'Not available'
          break
      }
      return (
        <div styleName='form-controls'>
          <div styleName='form-control-wrap'>
            <div styleName='fund-card-label'>
              Fund comparison settings
            </div>
            <div styleName='form-control-label'>
              Investment timeline<LinkIcon faclass='fa-calendar'/>
            </div>
            <div>
              <em>
                Performance as of:&nbsp;
                {moment(shareClass.performance_as_of_date).format('M/DD/YY')}
              </em>
            </div>
            { renderTimeHorizonButtongroup() }
          </div>
          <div styleName={'w100 form-control-wrap'}>
            <div styleName='form-control-label'>
              Benchmark<LinkIcon faclass='fa-sliders'/>
            </div>
            <div>
              <em>Suggested: {benchName}</em>
            </div>
            { this.renderBenchmarkSelect() }
          </div>
        </div>
      )
    }

    const renderResultsCardReturnsComparison = (shareClass) => {
      if (this.state.activeTimeHorizon){
        const horizon = this.state.activeTimeHorizon
        const share = shareClass[horizon.value] / 100.0
        const bench = this.state.benchmark[horizon.value] / 100.0
        const diff = share - bench
        const higherLower = (diff === 0)
                            ? 'Same'
                            : (diff > 0)
                            ? 'Higher'
                            : 'Lower'
        const moreLess = (diff === 0)
                         ? 'Same'
                         : (diff > 0)
                         ? 'more'
                         : 'less'
        const icon = (diff === 0)
                     ? 'right'
                     : (diff > 0)
                     ? 'up'
                     : 'down'
        const diffStyle = (diff === 0)
                          ? 'higher-lower'
                          : (diff > 0)
                          ? 'higher-good'
                          : 'lower-bad'
        // const iSrc = (diff === 0)
        //              ? require( '../../../static/images/icons_step1_gray.svg')
        //              : (diff > 0)
        //              ? require( '../../../static/images/icons_step1.svg')
        //              : require( '../../../static/images/icons_step1_red.svg')
        if (!isNaN(diff)) {
          return (
            <div styleName='card-center'>
              { /* <img
                src={iSrc}
                alt='Returns'
                styleName='cards-li-icon'
              /> */ }
              <div styleName='comparison-arrow-wrap'>
                <span styleName={diffStyle}>
                  <LinkIcon nospace={true} faclass={'fa-2x fa-arrow-circle-' + icon}/>
                </span>
              </div>
              <div styleName='higher-lower'>
                <span styleName={diffStyle}>
                  {higherLower}
                </span>
                &nbsp;{horizon.shortLabel} returns&nbsp;
                <div styleName={'small-higher-lower'}>
                  <span styleName={diffStyle}>
                    { /* (diff >= 0) ? '+' : null */ }
                    { format.perc(Math.abs(diff)) }
                    &nbsp;
                    { moreLess }
                  </span>
                  &nbsp;
                  in annualized returns
                </div>
              </div>
            </div>
          )
        }
        return (
          <div styleName='card-center'>
            <span> #ERROR </span>
          </div>
        )
      } else {
        return (
          <div styleName='card-center'>
            <NoReturnsAvailable />
          </div>
        )
      }
    }

    const renderResultsCardESGComparisons = (fund) => {
      return (
        <div>
          { // use EsgConfig.esgNamesLabels because it's in order
            EsgConfig.esgNamesLabels.map((key, idx)=>{
              // this ESG object
              const diff = this.state.esgDiffs[key.value]
              const thisEsg = EsgConfig.esgOptions[key.value]
              /* get ESG config fields */
              // diff formatted as number or percent
              let formatted = thisEsg.format(diff)
              // true if our diff is 'good', else false
              // const diffGood = thisEsg.diffGood(diff)
              //
              const label = thisEsg.label
              const unitsExpanded = thisEsg.unitsExpanded(diff)
              // use let for equal comparison styles (i.e. diff=0.0)
              let icon = (diff > 0) ? 'up' : 'down'
              let diffStyle = thisEsg.diffStyle(diff)
              let moreLess = thisEsg.moreLess(diff)
              // let imgIcon = (diffGood)
              //               ? require('../../../static/images/'
              //                         + thisEsg.icon
              //                         + '.svg' )
              //               : require('../../../static/images/'
              //                         + thisEsg.icon
              //                         + '_red.svg' )
              // special styles for equal diff (i.e. equal comparison)
              if (format.roundsToZero(diff)){
                icon = 'right'
                diffStyle = 'higher-same'
                moreLess = 'Same'
                // imgIcon = require('../../../static/images/'
                //                   + thisEsg.icon
                //                   + '_gray.svg')
              }

              // hack to trim negative from formatted number
              formatted = (formatted.slice(0,1) === '-') ? formatted.substring(1) : formatted

              if (!isNaN(diff)) {
                return (
                  <div key={key.value} styleName='card-center'>
                    { /* <img
                      src={imgIcon}
                      alt={thisEsg.valueLabel}
                      styleName='cards-li-icon'
                    /> */ }
                    <div styleName='comparison-arrow-wrap'>
                      <span styleName={diffStyle}>
                        <LinkIcon nospace={true} faclass={'fa-2x fa-arrow-circle-' + icon}/>
                      </span>
                    </div>
                    <div styleName='higher-lower'>
                      <span styleName={diffStyle}>
                        {moreLess}
                      </span>
                      &nbsp;
                      {label}
                      &nbsp;
                      <div styleName={'small-higher-lower'}>
                        <span styleName={diffStyle}>
                          { /* (diff >= 0) ? '+' : null */ }
                          {formatted}{unitsExpanded}
                        </span>
                        &nbsp;
                        {(moreLess==='Same')?null:moreLess.toLowerCase()}
                      </div>
                    </div>
                  </div>
                )
              }
              return null
            })
          }
        </div>
      )
    }

    const renderResultsCard = (shareClass, fund) => {
      return (
        <div
          styleName='form-comparison-wrap'
          onClick={() => {
            this.setState({
              showExpandable: !this.state.showExpandable
            })
          }}
        >
          <div styleName='fund-card-label'>
            Fund comparison results
          </div>
          <div>
            Compared to the benchmark, this fund has:
          </div>
          {
            (this.state.benchLoading || this.state.timeHorizonLoading) ? (
              <div style={{position: 'relative', height: '200px'}}>
                <div style={{position: 'relative'}}>
                  <Loader
                    options={{scale: 0.70, top:'2.0rem'}}
                    loaded={ false }
                  />
                </div>
              </div>
            ) : (
              <div>
                { renderResultsCardReturnsComparison(shareClass) }
                {
                  (fund.gef_score==='-1.0')
                  ? (
                    <div
                      styleName='card-center'
                      data-multiline={true}
                      data-effect='solid'
                      data-place={'left'}
                      data-for={'returns-esg-low-rated'}
                      data-html={true}
                      data-scroll-hide={false}
                      data-tip={"<div style='max-width:250px;font-weight:300;text-align:left;'>None of this fund's holdings were scored by Equileap. We couldn't calculate any gender-lens scores for this fund, and the fund was not included in our rankings.</div>"}
                    >
                      <div styleName='comparison-arrow-wrap'>
                        <LinkIcon faclass='fa-ban fa-2x' />
                      </div>
                      <div styleName='higher-lower'>
                        This fund is unscored
                      </div>
                      <ReactTooltip id='returns-esg-low-rated'/>
                    </div>
                  ) : renderResultsCardESGComparisons(fund)
                }
                { /*
                <button
                  styleName='explain-cards'
                  onClick={() => {
                    this.setState({
                      showExpandable: !this.state.showExpandable
                    })
                  }}
                >
                  View more financials
                  <LinkIcon
                    faclass={ (this.state.showExpandable)
                              ? 'fa-angle-up'
                              : 'fa-angle-down' }
                  />
                </button>
                */ }
              </div>
            )
          }
        </div>
      )
    }

    const renderFundCard = (shareClass) => {
      return (
        <div styleName='fund-card-wrap'>
          <div styleName='fund-card-fund'>
            <div styleName='fund-card-content-fund'>
              <div styleName='fund-card-ticker-top'>
                <span styleName='fund-card-ticker-span-top'>
                  Current fund
                </span>
              </div>
              <div styleName='fund-card-name'>
                { (shareClass.ticker) ? (
                  <div styleName='fund-card-name-ticker'>
                    {shareClass.ticker}
                  </div>
                  ) : null }
                <div styleName='fund-card-name-name'>
                  {shareClass.fund_legal_name}
                </div>
              </div>
              <div styleName='fund-card-type'>
                <div>
                  <div styleName='fund-card-type-label'>Family</div>
                  {shareClass.fund_family_name}
                </div>
                <div>
                  <div styleName='fund-card-type-label'>Category</div>
                  {shareClass.morningstar_category_name}
                </div>
              </div>
            </div>
          </div>
          <div styleName='fund-card-footer-link'>
            <Link
              to={config.routes.clean}
              title={'Find more funds | Search - ' + config.app.title}
            >
              <span styleName='fund-card-footer-link-label'>
                Find another fund<LinkIcon/>
              </span>
            </Link>
          </div>
        </div>
      )
    }

    const renderBenchmarkCard = () => {
      return (
        <div styleName='fund-card-wrap'>
          {
            (this.state.benchLoading) ? (
              <div styleName='fund-card-loading'>
                <div styleName='fund-card-loader-offset'>
                  <Loader
                    options={{scale: 0.70, top:'2.0rem'}}
                    loaded={ false }
                  />
                </div>
              </div>
            ) : (
              <div styleName='fund-card-benchmark'>
                <div styleName='fund-card-content-benchmark'>
                  <div styleName='fund-card-ticker-top'>
                    <span styleName={'fund-card-ticker-span-top b-ticker'}>
                      Benchmark
                    </span>
                  </div>
                  <div styleName='fund-card-name'>
                    <div styleName='fund-card-name-ticker'>
                      {this.state.benchmark.ticker}
                    </div>
                    <div styleName='fund-card-name-name'>
                      {this.state.benchmark.fund_legal_name}
                    </div>
                  </div>
                  <div styleName='fund-card-type'>
                    <div>
                      <div styleName='fund-card-type-label'>Family</div>
                      iShares from BlackRock
                    </div>
                    <div>
                      <div styleName='fund-card-type-label'>Category</div>
                      {this.state.benchmark.morningstar_category_name}
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          <div
            styleName='fund-card-footer-link'
            data-multiline={true}
            data-effect={'solid'}
            data-tip={
              "<div style='max-width:200px; font-size:12px;'>In the settings box, use the dropdown menu labeled 'Benchmark' to choose from a range of common benchmarks</div>"
            }
            data-for='benchmark-card-tooltip'
            data-place='top'
            data-html={true}
          >
            Change benchmark<LinkIcon faclass='fa-info-circle'/>
            <ReactTooltip id='benchmark-card-tooltip'/>
          </div>

        </div>
      )
    }

    /*
    Card table layout
    */
    const chartUrl = `https://iyv-charts.s3-us-west-2.amazonaws.com/gef_chartB/${_shareClass.fund_id}_gef_chartB.png`
    const chartAlt = `Returns chart for ${_shareClass.fund_legal_name}`
    return (
      <div styleName='returns-container'>
        <div styleName='returns-container-inner'>
          <div>
            { renderCardTableHeader(_shareClass) }
            <div styleName='cards-row'>

              <div styleName='chart-img-wrap'>
                <div styleName='chart-img-headline'>
                  Gender Equality and Returns
                </div>
                { this.state.activeTimeHorizon ? (
                    <div>
                      <Link to={chartUrl} title={'Enlarge chart'}>
                        <img
                          src={chartUrl}
                          alt={chartAlt}
                          styleName='chart-img'
                        />
                        <div>
                          <em>Enlarge</em><LinkIcon faclass='fa-search-plus'/>
                        </div>
                      </Link>
                      <div styleName='chart-img-caption'>
                        The figure above charts annualized returns and Gender Equality Fund grades. The orange marker represents this fund. The purple marker (if present) represents an assigned benchmark. Blue dots represent funds in the same Morningstar category as this fund. Dark gray dots represent funds in the same grading group as this fund. Returns are for the most recent available for this fund of 1, 3, 5, or 10 year annualized returns. The higher a fund is marked on the Y axis, the better its returns for the specified time period. The higher a fund is marked on the X axis, the better its Gender Equality Funds group ranking. Read more on the <Link to={config.routes.howitworks} title='How it Works' xstrong={true}>How it Works page.</Link>
                      </div>
                    </div>
                  ) : (
                    <NoReturnsAvailable />
                  ) }
                <div styleName='chart-img-headline-2'>
                  Benchmarking tool
                </div>
              </div>

              { /* DESKTOP
                   -------
                   |1|2|3|
                   | | |_|
                   | | |4|
                   | | | |
                   ------- */ }
              <Row styleName='visible-desktop'>
                <Col
                  md={8} lg={8}
                  styleName='cards-center'
                >
                  { renderFundCard(_shareClass) }
                  <div styleName='vs-col'>
                    vs.
                  </div>
                  { renderBenchmarkCard() }
                </Col>
                <Col
                  md={4} lg={4}
                  styleName='cards-center-vert'
                >
                  { renderSettingsCard(_shareClass) }
                  { renderResultsCard(_shareClass, _fund) }
                </Col>
              </Row>

              { /* TABLET
                   -----
                   |1|2|
                   |_|_|
                   |3|4|
                   | | |
                   ----- */ }
              <div styleName='visible-tablet'>
                <Row>
                  <Col
                    sm={12}
                    styleName='cards-center'
                  >
                    { renderFundCard(_shareClass) }
                    <div styleName='vs-col'>
                      vs.
                    </div>
                    { renderBenchmarkCard() }
                  </Col>
                </Row>

                <Row>
                  <Col
                    sm={6}
                    styleName='cards-center-vert'
                  >
                    { renderSettingsCard(_shareClass) }
                  </Col>
                  <Col
                    sm={6}
                    styleName='cards-center-vert'
                  >
                    { renderResultsCard(_shareClass, _fund) }
                  </Col>
                </Row>
              </div>

              { /* MOBILE
                   ----
                   |1 |
                   |__|
                   |2 |
                   |__|
                   |3 |
                   |__|
                   |4 |
                   |__|
                   ---- */ }
              <div styleName='visible-mobile'>
                <Row>
                  <Col
                    xs={12}
                    styleName='cards-center'
                  >
                    { renderFundCard(_shareClass) }
                    <div styleName='mobile-vs-col'>
                      vs.
                    </div>
                    { renderBenchmarkCard() }
                  </Col>
                </Row>
                <Row>
                  <Col
                    xs={12}
                    styleName='cards-center-vert'
                  >
                    { renderSettingsCard(_shareClass) }
                    { renderResultsCard(_shareClass, _fund) }
                  </Col>
                </Row>
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
 /* ------------------------ */


  /*
  renderSlideDown
  */
  renderSlideDown = (_shareClass, _fund) => {
    /*
    Bullet points
    */
    // const slideDownText = (shareClass) => {
    //   if (this.state.activeTimeHorizon) {
    //     return (
    //       <div styleName='h3'>
    //         If you invested in <strong>{shareClass.ticker || shareClass.fund_legal_name}</strong> { this.state.activeTimeHorizon.label } ago, compared to the benchmark <strong>{this.state.benchmark.ticker}</strong> you would have:
    //       </div>
    //     )
    //   } else {
    //     return (
    //       <div styleName='h3'>
    //         If you invested in <strong>{shareClass.ticker || shareClass.fund_legal_name}</strong>, compared to the benchmark <strong>{this.state.benchmark.ticker}</strong> you would have:
    //       </div>
    //     )
    //   }
    // }

    // const renderSlideDownReturnsBulletValue = (diff, moreLess, style) => {
    //   return (!isNaN(diff))
    //          ? (diff === 0)
    //          ? (<span><strong>the same amount</strong></span>) // diff = 0.0
    //          : (<span styleName={style}>
    //               {format.perc(Math.abs(diff))} {moreLess}
    //            </span>)                                        // diff = +/- %
    //          : (<span>#ERROR</span>)                           // diff = ???
    // }

    // const renderSlideDownReturnsBullet = (shareClass) => {
    //   let shareVal = null
    //   let benchVal = null
    //   let diff = null
    //   let moreLess = null
    //   let diffStyle = null
    //   let icon = null
    //   const horizon = this.state.activeTimeHorizon
    //   if (horizon && shareClass[horizon.value] !== '') {
    //     shareVal = shareClass[horizon.value] / 100.0
    //     benchVal = this.state.benchmark[horizon.value] / 100.0
    //     diff = shareVal - benchVal
    //     moreLess = (diff > 0)
    //                ? 'more'
    //                : 'less'
    //     diffStyle = (diff > 0)
    //                 ? 'positive'
    //                 : 'negative'
    //     icon = (diff === 0)
    //            ? require( '../../../static/images/icons_step1_gray.svg')
    //            : (diffStyle === 'positive')
    //            ? require( '../../../static/images/icons_step1.svg')
    //            : require( '../../../static/images/icons_step1_red.svg')
    //   }
    //   return (
    //     <div styleName='comparison-li'>
    //       { (icon) ? (<img
    //         src={icon}
    //         alt={'Returns'}
    //         styleName='comparison-li-icon'
    //       />) : null }
    //       { (this.state.activeTimeHorizon) ? (
    //           <div styleName='comparison-li-text'>
    //             made an average of
    //             &nbsp;
    //             <strong>
    //               { renderSlideDownReturnsBulletValue(diff,
    //                                                   moreLess,
    //                                                   diffStyle) }
    //             </strong>
    //             &nbsp;
    //             in annualized returns
    //           </div>
    //         ) : (
    //           <div styleName='comparison-li-text'>
    //             <NoReturnsAvailable />
    //           </div>
    //         ) }
    //     </div>
    //   )
    // }

    // const renderSlideDownEsgBullets = (shareClass) => {
    //   // for each ESG type, format and render the difference from benchmark
    //   return EsgConfig.esgNamesLabels.map((key, idx)=>{
    //     const diff = this.state.esgDiffs[key.value]
    //     const thisEsg = EsgConfig.esgOptions[key.value]

    //     let diffDescriptor = thisEsg.moreLess(diff).toLowerCase()

    //     // for some ESG types higher is better, vice versa for others
    //     const dir = thisEsg.direction
    //     const compareDirection = (dir === 'ascending')
    //                              ? (diff < 0)
    //                              : (diff > 0)
    //     let compareStyle = (compareDirection)
    //                          ? 'positive'
    //                          : 'negative'

    //     // icons change color based on good or bad results
    //     let icon = (compareStyle === 'positive')
    //                ? require('../../../static/images/'
    //                          + thisEsg.icon
    //                          + '.svg')
    //                : require('../../../static/images/'
    //                          + thisEsg.icon
    //                          + '_red.svg')

    //     // if the diff is equal, it gets a special set of styles
    //     const roundsToZero = (val) => {
    //       return (val > -0.5 && val < 0.5)
    //     }

    //     if (roundsToZero(diff)) {
    //       diffDescriptor = 'the same'
    //       compareStyle = ''
    //       icon = require('../../../static/images/'
    //                      + thisEsg.icon
    //                      + '_gray.svg')
    //     }

    //     const ticker = (shareClass.ticker) ? shareClass.ticker : 'N'
    //     const name = format.sanitize(shareClass.fund_legal_name)
    //     const page = thisEsg.page

    //     let url = config.routes.fund + '/'
    //               + name + '/' + ticker + '/'
    //               + page + '/' + shareClass.fund_id + '/'
    //               + shareClass.investment_vehicle_id

    //     /* hide the link to each ESG options dedicated page if that page is
    //        the active page (e.g. if we're on fossil page, don't add link to
    //        fund's fossil page after fossil comparison) */
    //     const hide = this.props.url.indexOf(thisEsg.page) >= 0
    //     url = (hide) ? null : url

    //     return (
    //       <div styleName='comparison-li' key={idx}>
    //         <img
    //           src={icon}
    //           alt={thisEsg.valueLabel}
    //           styleName='comparison-li-icon'
    //         />
    //         <div styleName='comparison-li-text'>
    //           { thisEsg.formatExpanded(Math.abs(diff),
    //                                    diffDescriptor,
    //                                    compareStyle,
    //                                    url) }
    //         </div>
    //       </div>
    //     )
    //   })
    // }

    /*
    Returns table
    */
    const renderTableHeadlines = (shareClass) => {
      return (
        <div>
          <div styleName='headline'>
            Month-end trailing returns
            &nbsp;
            <i
              className={'fa fa-info-circle'}
              data-multiline={true}
              data-effect={'solid'}
              data-tip={
                "<div style='max-width:300px; font-size:10px;'>Expressed in percentage terms, Morningstar's calculation of total return is determined each month by taking the change in monthly net asset value, reinvesting all income and capital-gains distributions during that month, and dividing by the starting NAV. Reinvestments are made using the actual reinvestment NAV, and daily payoffs are reinvested monthly. Unless otherwise noted, Morningstar does not adjust total returns for sales charges (such as front-end loads, deferred loads and redemption fees), preferring to give a clearer picture of a fund's performance. The total returns do account for management, administrative, 12b-1 fees and other costs taken out of fund assets. Total returns for periods longer than one year are expressed in terms of compounded average annual returns (also known as geometric total returns), affording a more meaningful picture of fund performance than non-annualized figures. Returns for periods longer than one year are expressed as annualized returns. This is equivalent to the compound rate of return which, over a certain period of time, would produce a fund's total return over that same period.</div>"
              }
              data-for='returns-headline-tooltip'
              data-place='bottom'
              data-html={true}
            />
            <ReactTooltip id='returns-headline-tooltip'/>
          </div>

          <div styleName='dateline'>
            <strong>Performance as of date:</strong>
            &nbsp;
            {moment(shareClass.performance_as_of_date).format('M/DD/YY')}
          </div>
          <div styleName='dateline'>
            <strong>Morningstar suggested benchmark:</strong>
            &nbsp;
            {shareClass.morningstar_primary_benchmark}
          </div>
        </div>
      )
    }

    const renderTableHeaderRow = () => {
      const renderEsgSelect = () => {
        const selectedEsg = (this.state.esg) ? {
          'label' : this.state.esg.valueLabel,
          'value' : this.state.esg.id
        } : null

        return (
          <div style={{ width:'175px' }}>
            <Select
              name='form-field-name'
              value={selectedEsg}
              onChange={this.esgOnChange}
              options={EsgConfig.esgNamesLabels}
              clearable={false}
            />
          </div>
        )
      }
      return (
        <div>
          <Row styleName='annual-return-top-row'>
            <Col xs={5} />
            <Col xs={4} styleName={'col-center gray'}>
              Annualized returns
            </Col>
            <Col xs={3} styleName={'col-center alt-color'}>
              Gender-lens analysis
            </Col>
          </Row>

          <Row styleName='annual-return-top-row'>
            <Col xs={5}/>
            {
              this.state.returnsTimeHorizon.map((timeHorizon, idx) => {
                return (
                  <Col key={idx} xs={1} styleName='col-center'>
                    {timeHorizon.shortLabel}
                  </Col>
                )
              })
            }
            <Col xs={3} styleName='col-center'>
              {
                (EsgConfig.esgNamesLabels.length > 1)
                ? renderEsgSelect()
                : this.state.esg.valueLabel
              }
            </Col>
          </Row>
        </div>
      )
    }

    const renderTableReturnValue = (returnVal) => {
      return (returnVal)
             ? (<span>{format.perc(returnVal / 100.0)}</span>)
             : (<span styleName='neutral'>/</span>)
    }

    const renderTableShareclassRow = (shareClass, fund) => {
      return (
        <Row styleName='annual-return-bottom-row'>
          <Col xs={5}>
            <strong>This fund</strong>
            <br/>
            {shareClass.ticker} - {shareClass.fund_legal_name}
          </Col>
          {
            this.state.returnsTimeHorizon.map((key, idx) => {
              return (
                <Col key={idx} xs={1} styleName='col-center'>
                  { renderTableReturnValue(shareClass[key.value]) }
                </Col>
              )
            })
          }
          <Col xs={3} styleName='col-center'>
          {
            (fund.gef_score==='-1.0')
            ? (
              <span
                data-multiline={true}
                data-effect='solid'
                data-place={'left'}
                data-for={'share-low-percent-rated'}
                data-html={true}
                data-scroll-hide={false}
                data-tip={"<div style='max-width:250px;font-weight:300;text-align:left;'>None of this fund's holdings were scored by Equileap. We couldn't calculate any gender-lens scores for this fund, and the fund was not included in our rankings.</div>"}
              >
                <LinkIcon
                  faclass='fa-exclamation-triangle'
                />
                <ReactTooltip id='share-low-percent-rated'/>
              </span>
            ) : this.renderEsgFormat(fund[this.state.esg.fieldLabel])
          }
          </Col>
        </Row>
      )
    }

    const renderTableBenchmarkRow = () => {
      const benchEsg = this.state.benchmark[this.state.esg.benchLabel]
      return (
        <Row styleName='annual-return-bottom-row'>
          <Col xs={5}>
            <strong>Benchmark</strong>
            <br/>
            { this.renderBenchmarkSelect() }
          </Col>
          {
            this.state.returnsTimeHorizon.map((key, idx) => {
              return (
                <Col key={idx} xs={1} styleName='col-center'>
                  { renderTableReturnValue(this.state.benchmark[key.value]) }
                </Col>
              )
            })
          }
          <Col xs={3} styleName='col-center'>
            { this.renderEsgFormat(benchEsg) }
          </Col>
        </Row>
      )
    }

    const renderTableComparisonRow = (fund) => {
      const renderReturnComparison = (val) => {
        // if diff is equal (0.0) or doesn't exist, return defaults
        if (val === 0.0) {
          return (<span>+0%</span>)
        } else if (!val) {
          return (<span styleName='neutral'>/</span>)
        }

        // if we have a diff, find positive or negative
        const diffStyle = (val > 0)
                          ? 'positive'
                          : 'negative'

        const diffFa = (val > 0)
                       ? 'fa-arrow-up'
                       : 'fa-arrow-down'

        return (
          <span styleName={diffStyle}>
            {format.perc(val / 100.0)}<LinkIcon faclass={diffFa}/>
          </span>
        )
      }

      const renderTableEsgComparison = (__fund) => {
        // render comparison for the active ESG
        const diff = this.state.esgDiffs[this.state.esg.id]

        // if diff is equal (0.0), return default
        if (format.roundsToZero(diff)) {
          return (<span>Same</span>)
        }

        // if we have a diff, find format parameters
        const higherLower = (diff > 0)
                            ? 'higher'
                            : 'lower'

        const compareDirection = (this.state.esg.direction === 'ascending')
                                 ? (diff < 0)
                                 : (diff > 0)

        const compareStyle = (compareDirection)
                             ? 'positive'
                             : 'negative'

        return (__fund.gef_score==='-1.0')
               ? (
                <span
                  data-multiline={true}
                  data-effect='solid'
                  data-place={'left'}
                  data-for={'table-esg-low-percent-rated'}
                  data-html={true}
                  data-scroll-hide={false}
                  data-tip={"<div style='max-width:250px;font-weight:300;text-align:left;'>None of this fund's holdings were scored by Equileap. We couldn't calculate any gender-lens scores for this fund, and the fund was not included in our rankings.</div>"}
                >
                  <LinkIcon
                    faclass='fa-exclamation-triangle'
                  />
                  <ReactTooltip id='table-esg-low-percent-rated'/>
                </span>
              ) : (
                <span styleName={compareStyle}>
                  { this.renderEsgFormat(diff, true) }
                  &nbsp;
                  {higherLower}
                </span>
              )
      }

      return (
        <Row styleName='annual-return-bottom-row'>
          <Col xs={5}>
            <strong>Fund compared to benchmark</strong>
            <br/>
            &nbsp;
          </Col>
          {
            this.state.activeTimeHorizon ?
              this.state.returnDiffs.map((val, idx) => {
                return (
                  <Col key={idx} xs={1} styleName='col-center'>
                    { renderReturnComparison(val) }
                  </Col>
                )
              }) : (
                <Col xs={4} styleName='col-center'>
                  <NoReturnsAvailable />
                </Col>
              )
          }
          <Col xs={3} styleName='col-center'>
            { renderTableEsgComparison(fund) }
          </Col>
        </Row>
      )
    }

    const renderMorningstarTextLink = (shareClass) => {
      const url = this.state.morningstarUrl
      const ticker = shareClass.ticker || shareClass.fund_legal_name
      return (
        <Link
          to={url}
          xstrong={true}
          log={analytics.eventToMorningstar(shareClass.investment_vehicle_id)}
          styleName='em'
        >
          Find more financial data on {ticker} at Morningstar.com<LinkIcon />
        </Link>
      )
    }

    /*
    SlideDown layout
    */
    return (
      <div styleName='returns-container'>
        <div styleName='explain-container-inner'>
          <SlideDown styleName='slide-down'>
            { /* !this.state.showExpandable */ }
            { false ? null : (
              <div styleName='slide-down-bg'>
                { /*
                { slideDownText(_shareClass) }
                 <div styleName='comparisons'>
                  { renderSlideDownReturnsBullet(_shareClass) }
                  { renderSlideDownEsgBullets(_shareClass) }
                </div>
                */ }
                <div styleName='returns-table'>
                  { renderTableHeadlines(_shareClass) }
                  <div styleName={'table-wrap hidden-xs'}>
                    { renderTableHeaderRow() }
                    <div styleName='line'/>
                    { renderTableShareclassRow(_shareClass, _fund) }
                    <div styleName='line'/>
                    { renderTableBenchmarkRow() }
                    <div styleName='line'/>
                    { renderTableComparisonRow(_fund) }
                  </div>
                  { renderMorningstarTextLink(_shareClass) }
                </div>
              </div>
            ) }
          </SlideDown>
        </div>
      </div>
    )
  }
  /* ------------------------ */

  render() {
    const shareClass = this.props.shareClass
    const fund = this.props.fund
    return (
      <div styleName='returns-wrap'>
        { this.renderCardTable(shareClass, fund) }
        { this.renderSlideDown(shareClass, fund) }
      </div>
    )
  }
}
